import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppInterface } from '../../interfaces/app.interface';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ResetStartpageService {
  private resetStartpageEndpoint = '/me/startpage';

  constructor(private http: HttpClient) {}

  resetStartPage(): Observable<any> {
    return this.http.delete<AppInterface[]>(
      environment.baseUrl + this.resetStartpageEndpoint,
    );
  }
}
